import * as React from 'react';

import {ButtonCard} from '../card/button-card';
import {Body} from '../typography/body';
import {Title} from '../typography/title';

import styles from './single-select-cards.module.css';

type CardTab = {
    id: string;
    title?: string;
    subtitle?: string | React.ReactNode;
};

type Props = {
    cards: CardTab[];
    selectedId: string | null | undefined;
    onSelect: (arg1: string) => void;
    // Optionally use 'small' variant of card
    smallVariant?: boolean;
};

export function SingleSelectCards(props: Props) {
    return (
        <div className={styles.container}>
            {props.cards.map((card) => {
                return (
                    <ButtonCard
                        isSelected={card.id === props.selectedId}
                        key={card.id}
                        onClick={() => {
                            props.onSelect(card.id);
                        }}
                    >
                        <div
                            className={
                                props.smallVariant
                                    ? styles['card-body--small']
                                    : styles['card-body']
                            }
                        >
                            <Title>{card.title}</Title>
                            {card.subtitle ? <Body>{card.subtitle}</Body> : undefined}
                        </div>
                    </ButtonCard>
                );
            })}
        </div>
    );
}
